module.exports = __webpack_public_path__ + "static/img/ye.b5840a84.svg";